import { render } from "./LoginPage.vue?vue&type=template&id=be02d088&scoped=true"
import script from "./LoginPage.vue?vue&type=script&lang=js"
export * from "./LoginPage.vue?vue&type=script&lang=js"

import "../assets/css/login.css?vue&type=style&index=0&id=be02d088&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be02d088"]])

export default __exports__